import {
  SelectContainer,
  QuestionText,
  QuestionAnswerContainer,
  SelectElement,
  OptionElement,
} from './styled';

export const SelectStep = ({
  currentQuestion,
  answerItem,
  generateAnswersObject,
}) => {
  const handleInputChange = (e) => {
    generateAnswersObject({
      position: currentQuestion.position,
      question: currentQuestion.question,
      selectedAnswers: [e.target.value],
    });

  };

  return (
    <SelectContainer>
      <QuestionText> {currentQuestion.question} </QuestionText>
      <QuestionAnswerContainer>
        <SelectElement
          name="select"
          onChange={handleInputChange}
          defaultValue={'ChooseCity'}
          value={answerItem?.selectedAnswers?.[0]}
          id="select-box" 
        >
          <OptionElement value="ChooseCity" disabled>
            Select
          </OptionElement>
          {currentQuestion.answer.map((item) => (
            <OptionElement
              key={`${item.label}-index`}
              value={item.value}
              selected={item.value === answerItem?.selectedAnswers?.[0]}
            >
              {item.label}
            </OptionElement>
          ))}
        </SelectElement>
      </QuestionAnswerContainer>
    </SelectContainer>
  );
};
